export default {
  label: 'Sentimento',
  placeholder: 'Todos',
  notClassified: 'Não Classificados',
};
